import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, GlobeIcon, LibraryIcon, SunIcon } from 'lucide-react';
import { MOCKUP_URL } from '../data/content';
const chips = [{
  icon: ZapIcon,
  label: 'Acceso en 5 min',
  short: '5 min'
}, {
  icon: GlobeIcon,
  label: 'España y Latinoamérica',
  short: 'ES + LATAM'
}, {
  icon: LibraryIcon,
  label: '5 Tomos + 5 Bonos',
  short: '5 + 5'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink-950 pb-16 pt-5 sm:pt-14" style={{
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "0px",
    paddingRight: "0px",
    marginTop: "0px",
    marginBottom: "0px",
    marginLeft: "0px",
    marginRight: "0px"
  }} data-id="element-100" data-mp="12862k3i3uktp">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-center px-4 text-center sm:px-6" style={{
      paddingTop: "0px",
      paddingBottom: "0px",
      marginTop: "0px",
      marginBottom: "0px"
    }} data-id="element-101" data-mp="nbez9j5b8oyt">
        <p className="font-display text-[11px] font-700 uppercase tracking-[0.28em] text-gold" style={{
        fontSize: "12px"
      }} data-id="element-102" data-mp="3814c5qmge0ov">
          ☀ KODA DIGITAL
        </p>

        <p className="mt-4 font-display text-lg font-800 leading-snug text-white sm:mt-6 sm:text-2xl" style={{
        fontSize: "24px",
        color: "#F2B41C"
      }} data-id="element-103" data-mp="3o6aqnxwkkb10">
          ⚠️ ALTO : Antes de Instalar Paneles Solares, Lee Esto
        </p>

        <h1 className="mt-2 font-display text-4xl font-900 leading-[1.04] tracking-tight text-white sm:mt-3 sm:text-5xl lg:text-[3.4rem]" style={{
        fontSize: "20px",
        textAlign: "center",
        backgroundColor: "#000000",
        color: "#FFFFFF",
        fontWeight: "800"
      }} data-id="element-104" data-mp="30i19xae7qdgq">
          🔒 Protégete de  Estafas (Que Afectan al 73% de Instalaciones)
          <span className="block text-gold" style={{
          fontSize: "20px"
        }} data-id="element-105" data-mp="2vj7wtj2u8oh3">
</span>
        </h1>
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-4 w-full max-w-[290px] sm:mt-6 sm:max-w-[420px]" data-id="element-106" data-mp="2hlj7nz1qmv68">
          <img src={`${MOCKUP_URL}?width=560&quality=65&format=webp`} srcSet={`${MOCKUP_URL}?width=320&quality=65&format=webp 320w, ${MOCKUP_URL}?width=560&quality=65&format=webp 560w, ${MOCKUP_URL}?width=840&quality=65&format=webp 840w`} sizes="(min-width: 640px) 420px, 290px" alt="Paneles solares en el tejado, factura de luz reducida un 90% y dueño de casa revisando su ahorro" className="h-auto w-full rounded-xl object-contain" width={420} height={344} fetchPriority="high" decoding="async" data-id="element-107" data-mp="na08cwk1yzd4" />
        </motion.div>

        <p className="mt-3 max-w-2xl text-lg leading-relaxed text-slate-300 sm:mt-5" style={{
        fontSize: "18px",
        fontWeight: "400",
        fontFamily: "Avenir, sans-serif",
        marginTop: "0px",
        marginBottom: "0px"
      }} data-id="element-108" data-mp="114kkctppmml6">
          Evaluá cualquier presupuesto solar sin ser técnico, y CON SEGURIDAD, SIN ERRORES, y CON ROI CLARO 
        </p>

        <ul className="mt-4 flex w-full items-center justify-center gap-2 sm:mt-5 sm:gap-2.5" style={{
        paddingTop: "10px",
        paddingBottom: "10px",
        marginTop: "0px",
        marginBottom: "0px"
      }} data-id="element-109" data-mp="1xb5q6f7x0tgn">
          {chips.map(chip => <li key={chip.label} className="flex items-center gap-1.5 whitespace-nowrap rounded-full border border-ink-700 bg-ink-900 px-3 py-1.5 text-[12.5px] font-500 leading-none text-slate-200 sm:px-3.5 sm:text-sm" style={{
          height: "20px"
        }} data-id="element-110" data-mp="2b0fy9k5iavdx">
              <chip.icon className="h-3.5 w-3.5 flex-none text-gold sm:h-4 sm:w-4" aria-hidden="true" data-id="element-111" data-mp="2l100ap0uo3x7" />
              <span className="sm:hidden" data-id="element-112" data-mp="2oyebunc06nsd">{chip.short}</span>
              <span className="hidden sm:inline" data-id="element-113" data-mp="2tyadifx8a34r">{chip.label}</span>
            </li>)}
        </ul>

        <a href="#precios" className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-gold px-8 py-3.5 font-display text-base font-800 uppercase tracking-wide text-ink-950 transition-[transform,background-color] duration-150 ease-smooth hover:bg-gold-400 active:scale-[0.985] sm:w-auto sm:text-lg" style={{
        height: "64px",
        paddingTop: "38px",
        paddingBottom: "38px"
      }} data-id="element-114" data-mp="unixt5i1ugi7">
          <SunIcon className="h-5 w-5" aria-hidden="true" data-id="element-115" data-mp="e8scvec7iwge" />
          ✓   SI,  QUIERO MI CÓDIGO SOLAR AHORA    ✓
        </a>

      </div>

    </header>;
}